export const sage200 = {
  sage200_discrepancy_item_po_notattached: `El artículo "{{1}}" no tiene una orden de compra asociada.`,
  // sage200_matching_discrepancy_item_quantity_mismatch: `La cantidad del artículo {{2}}, combinada con la cantidad total consumida {{6}}, no coincide con la orden de compra {{3}}, que especifica una cantidad de {{4}}. Las cantidades se han consumido en los documentos {{5}}.`,
  sage200_matching_discrepancy_item_quantity_mismatch: `La cantidad de factura {{2}}, combinada con la cantidad total consumida {{6}} de documentos anteriores {{5}}, no coincide con {{3}}, que especifica una cantidad de {{4}}.`,
  sage200_discrepancy_item_quantity_mismatch: `{{1}} tiene {{2}} en la factura pero {{4}} en la orden de compra {{3}}`,
  // sage200_discrepancy_item_unitprice_mismatch: `El precio unitario '{{2}}' en el artículo '{{1}}' no coincide con el precio unitario '{{4}}' en el pedido '{{3}}'`,
  sage200_discrepancy_item_unitprice_mismatch: `{{1}} es '{{2}}' en la factura pero {{4}} en el pedido {{3}}`,
  sage200_discrepancy_item_unitprice_missing:
    "El precio unitario falta en el artículo",
  sage200_discrepancy_poitem_unitprice_missing:
    "El precio unitario falta en el artículo de orden de compra",
  sage200_discrepancy_item_quantity_missing: "La cantidad falta en el artículo",
  sage200_discrepancy_poitem_quantity_missing:
    "La cantidad falta en el artículo de orden de compra",
  adjusted_for_prior_consume: "AJUSTADO SEGÚN {{document}}",
  matched: "Coincidente",
  all: "Todo",
  discrepancies: "Discrepancias",
  matching_document_not_found: "Documento de coincidencia no encontrado",
  dicrepancies_matching: "Coincidencias y discrepancias",
  line_matching: "Alineación de Líneas",

  sage200_discrepancy_item_dn_notattached: `Falta la referencia de la nota de entrega en el artículo '{{1}}'`,
  sage200_discrepancy_dnitem_quantity_missing: `Falta la cantidad en el elemento`,
  sage200_discrepancy_dnitem_unitprice_missing: `Falta el precio unitario en el elemento`,

  "Sage200 IN<>DN": `Sage 200 Factura <> Nota de entrega`,

  Sage200_INDN_DN_NotAttached: `Nota de entrega no adjunta`,
  Sage200_INDN_DN_NotAttached_description: `La nota de entrega referenciada no está adjunta o no se pudo encontrar.`,

  Sage200_INDN_Quantity_NotMatch: `La cantidad no coincide`,
  Sage200_INDN_Quantity_NotMatch_description: `La cantidad de la factura no coincide con la cantidad de la nota de entrega.`,

  Sage200_INDN_UnitPrice_NotMatch: `El precio unitario no coincide`,
  Sage200_INDN_UnitPrice_NotMatch_description: `El precio unitario de la factura no coincide con el precio unitario de la nota de entrega.`,
  sage200_discrepancy_item_contract_notattached: `Contrato no adjunto`,
  sage200_incntrct_discrepancy_item_quantity_missing: `Falta la cantidad del artículo`,
  sage200_incntrct_discrepancy_contractitem_quantity_missing: `Falta la cantidad en el artículo del contrato`,
  sage200_incontrct_matching_discrepancy_item_quantity_mismatch: `La cantidad del artículo '{{2}}', junto con la cantidad total consumida '{{6}}', no coincide con el contrato '{{3}}', que especifica una cantidad de '{{4}}'. Se han consumido cantidades en los documentos '{{5}}'.`,
  sage200_incntrct_discrepancy_item_quantity_mismatch: `La cantidad '{{2}}' del artículo '{{1}}' no coincide con la cantidad '{{4}}' del contrato '{{3}}'`,
  sage200_incontrct_discrepancy_item_unitprice_mismatch: `El precio unitario '{{2}}' del artículo '{{1}}' no coincide con el precio unitario '{{4}}' del contrato '{{3}}'`,
  indn_account_class_required:
    "Se requiere la clasificación de la cuenta para este elemento de solicitud.",
  Sage200_INCONTRACT_Contract_NotAttached: `Contract not attached`,
  Sage200_INCONTRACT_Quantity_NotMatch: `Quantity does not match in contract`,
  Sage200_INCONTRACT_UnitPrice_NotMatch: `Unit price does not match in contract`,
};
